// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"4a22c9bb58633df0","node_modules_canvg_lib_index_es_js":"cd5549d04b681ca5"}[chunkId] + ".js";
};